import { render, staticRenderFns } from "./CarbonCostByMethod.vue?vue&type=template&id=64df0dc0&scoped=true"
import script from "./CarbonCostByMethod.vue?vue&type=script&lang=js"
export * from "./CarbonCostByMethod.vue?vue&type=script&lang=js"
import style0 from "./CarbonCostByMethod.vue?vue&type=style&index=0&id=64df0dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df0dc0",
  null
  
)

export default component.exports